export enum RuleTypeDefinition {
  FOLDER = 'dossier',
  ELEMENT = 'input',
  STATE = 'state',
}
